/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface MedicalSystemOptionsCatalogDto
 */
export interface MedicalSystemOptionsCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    subCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    beamLimitingDeviceType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    beamProduction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MedicalSystemOptionsCatalogDto
     */
    $type?: MedicalSystemOptionsCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const MedicalSystemOptionsCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoMedicalSystemOptionsCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.MedicalSystemOptionsCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type MedicalSystemOptionsCatalogDtoTypeEnum = typeof MedicalSystemOptionsCatalogDtoTypeEnum[keyof typeof MedicalSystemOptionsCatalogDtoTypeEnum];



/**
 * Check if a given object implements the MedicalSystemOptionsCatalogDto interface.
 */
export function instanceOfMedicalSystemOptionsCatalogDto(value?: unknown): value is MedicalSystemOptionsCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(MedicalSystemOptionsCatalogDtoTypeEnum)[0];
}

export function MedicalSystemOptionsCatalogDtoFromJSON(json: any): MedicalSystemOptionsCatalogDto {
    return MedicalSystemOptionsCatalogDtoFromJSONTyped(json, false);
}

export function MedicalSystemOptionsCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemOptionsCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'subCategory': json['subCategory'] == null ? undefined : json['subCategory'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'beamLimitingDeviceType': json['beamLimitingDeviceType'] == null ? undefined : json['beamLimitingDeviceType'],
        'beamProduction': json['beamProduction'] == null ? undefined : json['beamProduction'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function MedicalSystemOptionsCatalogDtoToJSON(value?: MedicalSystemOptionsCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'category': value['category'],
        'subCategory': value['subCategory'],
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        'subModel': value['subModel'],
        'beamLimitingDeviceType': value['beamLimitingDeviceType'],
        'beamProduction': value['beamProduction'],
        '$type': value['$type'],
    });
}

